<template>
  <div class="pt-business-order-lot-form" v-loading.fullscreen.lock="loading" element-loading-text="正在处理中，请稍后">
    <pt-form-item label="上传样品Excel文件：" :required="true" labelWidth="150px">
      <!-- 上传组件 -->
      <el-upload ref="excel" class="upload-demo" action="aa" :auto-upload="false" :multiple="false" :on-change="changHandler" :on-remove="removeHandler" :file-list="excel" v-model="lotForm.excel" name="excel" v-validate="'required'" data-vv-as="上传文件">
        <el-button size="small" type="primary">点击上传</el-button>
        <!-- <a style="margin-left:10px" :href="$privateResourcesUrlDownload + this.tenant+ '/templates/样品创建模板.xlsx'"> -->
          <el-button @click="downloadTemplate" type="text">下载样品Excel模板</el-button>
        <!-- </a> -->
        <br>
      </el-upload>
    </pt-form-item>
    <pt-form-item label="快递单号：" labelWidth="150px">
      <div v-for="(item,i) in lotForm.courierNumber" :key="i">
        <el-input placeholder="请填写快递单号" v-model="item.value" :class="'courier_'+i"></el-input>
        <el-button style="margin-left:10px" type="text" @click="deleteItem(i)">删除</el-button><br>
        <el-button type="text" @click="addItem(i)" v-show="i==lotForm.courierNumber.length-1">添加一条</el-button>
      </div>
    </pt-form-item>

    <slot />
  </div>
</template>

<script>
import formMixins from 'mixins/form'
// 组件class前缀
// import { handleWorkFlow } from 'cps/lab-order/pt-lab-order-form/form-required-option'

export default {
  name: 'order-excel-form',
  mixins: [formMixins],
  computed: {
    tenant () {
      return this.$store.state.saasConfig.tenant
    }
  },
  data () {
    return {
      lotForm: {
        clientOrganizationId: '',
        remark: '',
        sender: '',
        courierNumber: [{ value: '' }],
        excel: []
      },
      excel: [],
      uploadForm: new FormData(),
      loading: false,
      contractId: [],
      workflow: ''
    }
  },
  methods: {
		downloadTemplate(){
			location.href = `${this.$privateResourcesUrlDownload}${this.tenant}/templates/样品创建模板.xlsx`
		},
    downLoadFile () {
      // this.$privateResourcesUrlDownload()rawdata/0001/sample_FinalReport_0001.txt
    },
    addItem (index) {
      if (this.lotForm.courierNumber[index].value === '') {
        this.$message.error('请填写快递单号！')
        return
      }
      this.lotForm.courierNumber.push({ value: '' })
      this.$nextTick(() => {
        document.querySelector('.courier_' + (index + 1) + '>input').focus()
      })
    },
    deleteItem (index) {
      if (index === 0 && this.lotForm.courierNumber.length === 1) {
        this.$message.error('不能再删除了')
        return
      }
      this.$confirm('确定要删除该条快递吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.lotForm.courierNumber.splice(index, 1)
      })
    },
    changHandler (file, fileList) {
      if (fileList.length > 1) {
        fileList.shift()
      }
      this.excel = fileList
      this.lotForm.excel = fileList
    },
    removeHandler (file, fileList) {
      this.excel = fileList
      this.lotForm.excel = fileList
    },
    async submit () {
      this.loading = true
      this.uploadForm = new FormData()
      this.uploadForm.append('excel', this.excel[0].raw)
      // 不同视角使用不同的workflow
      // let workflow = this.workflow
      let workflow = 'LAB_ORDER_CREATED'
      let fileUrl = await this.$store.dispatch('uploadTempFile', { file: this.excel[0].raw })
      this.uploadForm.append('workflow', workflow)

      this.uploadForm.append('expressNumber', this.lotForm.courierNumber ? this.lotForm.courierNumber.map(e => e.value) : '')
      this.uploadForm.append('fileUrl', fileUrl.data)
      this.uploadForm.append('asyncImport', true)
      this.$store.dispatch('createBatchOrder', this.uploadForm).then(res => {
        console.log('rees', res)
        if (res.hasError) {
          this.loading = false
          this.lotForm.excel[0].status = 'ready'
          this.excel[0] = this.lotForm.excel[0]
          this.$emit('errorMsg', res.errors)
        } else {
          this.getSamplesjobRecord(res.data.jobRecord && res.data.jobRecord.id)
        }
      }).catch((error) => {
        this.loading = false
        this.lotForm.excel[0].status = 'ready'
        this.excel[0] = this.lotForm.excel[0]
        this.$message.error(error)
        this.$emit('errorMsg')
      })
    },
    getSamplesjobRecord (data) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('getSamplesjobRecord', data).then(res => {
          if (res.status === 'PROCESSING') {
            resolve(setTimeout(() => {
              this.getSamplesjobRecord(data)
            }, 5000))
          } else if (res.status === 'COMPLETED') {
            this.excel[0].status = 'ready'
            this.loading = false
            if (this.$route.query.isSamplePlate) {
              this.$router.push({ name: 'sample-board-list' })
            } else {
              this.$router.push({ name: 'gene-lab-order' })
            }
          } else if (res.status === 'UNKNOWN') {
            this.loading = false
            let data = [
              { errorMsg: [res.unknownDetails] }
            ]
            this.$emit('errorMsg', data)
          } else if (res.status === 'FAILED') {
            this.loading = false
            this.$alert(`有${res.countFailed}条样本导入失败，请在异常样本中查看详情`, '提示', {
              confirmButtonText: '确定',
              callback: action => {
                if (this.$route.query.isSamplePlate) {
                  this.$router.push({ name: 'sample-board-list' })
                } else {
                  this.$router.push({ name: 'gene-lab-order' })
                }
              }
            })
          }
        }).catch(err => {
          this.$message.error(err)
        })
      })
    }
  },
  created () {
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-business-order-lot-form {
  :global {
    .el-loading-spinner {
      top: 10%;
    }
  }
  .el-input,
  el-date-editor {
    width: 280px !important;
  }
  .el-upload-list {
    max-width: 800px;
  }
  el-textarea,
  .el-textarea__inner {
    width: 500px;
    font-family: "Microsoft YaHei", "微软雅黑", "Avenir", Helvetica, Arial;
  }
  .dashed {
    margin: 30px 0;
    height: 1px;
    background-image: linear-gradient(
      to right,
      #ccc 0%,
      #ccc 50%,
      transparent 50%
    );
    background-size: 8px 1px;
    background-repeat: repeat-x;
  }
}
</style>
